import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DARK_THEME, DarkThemeService } from '@irohalab/deneb-ui';

const LIGHT_LOGO = 'assets/mira-logo.svg';
const DARK_LOGO = 'assets/mira-logo-dark.svg';

@Component({
  selector: 'app-mira-logo',
  imports: [NgOptimizedImage],
  template: '<img [ngSrc]="source()" [width]="width()" [height]="height()" alt="">',
  styles: `
    :host {
      display: inline-block;
      line-height: 0;
    }

    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MiraLogoComponent {
  readonly width = input.required<number>();
  readonly height = input.required<number>();

  protected readonly source = signal(LIGHT_LOGO);

  private readonly darkThemeService = inject(DarkThemeService);

  constructor() {
    this.darkThemeService.themeChange
      .pipe(takeUntilDestroyed())
      .subscribe((theme) => this.source.set(theme === DARK_THEME ? DARK_LOGO : LIGHT_LOGO));
  }
}